import * as React from 'react';
import { styled } from 'stitches.config';

import Typography from '@/components/sushi/Typography';

const BlogSubCategoriesContainer = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 40,
});

const BLOG_CATEGORY_SECTION_WIDTH = 300;

export const SitemapBlogCategory = ({ category }) => {
  return (
    <div className="flex flex-col lg:flex-row">
      <Typography
        as="a"
        href={`${process.env.NEXT_PUBLIC_PUBLIC_PATH}${category.publishedPath}`}
        target="_blank"
        variant="bodyXL"
        color="primaryAlt"
        className="lg:mr-4 mb-4"
        style={{
          width: BLOG_CATEGORY_SECTION_WIDTH,
          minWidth: BLOG_CATEGORY_SECTION_WIDTH,
        }}>
        {category.title}
      </Typography>

      <BlogSubCategoriesContainer>
        {category.categories?.map(({ title, publishedPath, categories }) => (
          <div style={{ width: BLOG_CATEGORY_SECTION_WIDTH }}>
            <Typography
              as="a"
              href={`${process.env.NEXT_PUBLIC_PUBLIC_PATH}${publishedPath}`}
              variant="bodyL"
              color="primaryAlt">
              {title}
            </Typography>

            {categories.length > 0 ? (
              <div className="mt-1 flex flex-col">
                {categories.map(({ title, publishedPath }) => (
                  <Typography
                    as="a"
                    href={`${process.env.NEXT_PUBLIC_PUBLIC_PATH}${publishedPath}`}
                    variant="bodyM"
                    color="primaryAlt">
                    {title}
                  </Typography>
                ))}
              </div>
            ) : null}
          </div>
        ))}
      </BlogSubCategoriesContainer>
    </div>
  );
};
